import React from 'react'

interface JoubiniProps {
  size?: number | string
}

export const Joubini: React.FC<JoubiniProps> = ({ size = 240 }) => {
  // Calculate the height based on the aspect ratio of 4:1
  const width = size
  const height = typeof size === 'number' ? size / 4 : `calc(${size} / 4)`

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 240 60"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 2,
      }}
      aria-label="Joubini Logo"
    >
      <g transform="matrix(1.08794,0,0,1.22449,-10.8794,-1.22449)">
        <rect x="10" y="1" width="220.6" height="49" style={{ fill: 'none' }} />
        <g
          id="joubini"
          transform="matrix(0.919167,0,0,0.816667,23.7718,-2.43917)"
        >
          {/* I */}
          <rect
            aria-label="I"
            x="208.5"
            y="17"
            width="2.1"
            height="29"
            style={{ fill: 'white', fillRule: 'nonzero' }}
          />

          {/* N */}
          <path
            aria-label="N"
            d="M192.2,17L192.2,46.1L190.4,46.1L170.7,20.8L170.7,46.1L168.5,46.1L168.5,17L170.3,17L190.1,42.2L190.1,17L192.2,17Z"
            style={{ fill: 'white', fillRule: 'nonzero' }}
          />

          {/* I */}
          <rect
            aria-label="I"
            x="150.1"
            y="17"
            width="2.1"
            height="29"
            style={{ fill: 'white', fillRule: 'nonzero' }}
          />

          {/* B */}
          <path
            aria-label="B"
            d="M136.3,38.4C136.3,43.3 132.7,46.1 125.6,46.1L112.7,46.1L112.7,17L124.8,17C131,17 134.8,19.6 134.8,24.4C134.8,27.8 132.9,30.1 129.9,31C134,31.9 136.3,34.4 136.3,38.4ZM114.8,18.8L114.8,30.4L124.7,30.4C129.7,30.4 132.6,28.5 132.6,24.6C132.6,20.8 129.7,18.8 124.7,18.8L114.8,18.8ZM134.2,38.2C134.2,34.1 131.2,32.2 125.6,32.2L114.8,32.2L114.8,44.2L125.6,44.2C131.2,44.2 134.2,42.4 134.2,38.2Z"
            style={{ fill: 'white', fillRule: 'nonzero' }}
          />

          {/* U */}
          <path
            aria-label="U"
            d="M74.1,33.7L74.1,17L76.2,17L76.2,33.6C76.2,40.9 79.7,44.3 85.7,44.3C91.8,44.3 95.2,40.9 95.2,33.6L95.2,17L97.3,17L97.3,33.7C97.3,42 92.9,46.2 85.6,46.2C78.3,46.2 74.1,42 74.1,33.7Z"
            style={{ fill: 'white', fillRule: 'nonzero' }}
          />

          {/* O */}
          <path
            aria-label="O"
            d="M30.6,31.5C30.6,23.1 37,16.8 45.7,16.8C54.3,16.8 60.8,23.1 60.8,31.5C60.8,40 54.3,46.2 45.7,46.2C37,46.3 30.6,40 30.6,31.5ZM58.7,31.5C58.7,24.2 53.1,18.7 45.8,18.7C38.4,18.7 32.8,24.1 32.8,31.5C32.8,38.8 38.4,44.3 45.8,44.3C53.1,44.3 58.7,38.9 58.7,31.5Z"
            style={{ fill: 'white', fillRule: 'nonzero' }}
          />

          {/* J */}
          <path
            aria-label="J"
            d="M0,40.9L1.8,39.8C3.6,42.8 5.5,44.4 8.9,44.4C12.4,44.4 15.2,41.7 15.2,36.7L15.2,17L17.3,17L17.3,36.4C17.3,39.7 16.3,42.3 14.7,43.9C13.2,45.4 11.1,46.2 8.8,46.2C4.4,46.3 1.8,44 0,40.9Z"
            style={{ fill: 'white', fillRule: 'nonzero' }}
          />

          {/* Blur */}
          {[...Array(5)].map((_, index) => (
            <path
              key={`blur-path-${index}`}
              d="M0,40.9L1.4,40C3.6,43.4 5.2,44.3 8.8,44.3C12.3,44.3 15.1,41.6 15.1,36.6L15.1,17L16.6,17L16.6,36.4C16.6,39.7 15.9,41.9 14.4,43.6C13,45.3 11,46.2 8.7,46.2C4.4,46.3 1.8,44 0,40.9Z"
              style={{
                fill: 'url(#linearGradient)',
                fillRule: 'nonzero',
                filter: `blur(${index * 2}px)`,
              }}
            >
              <animate
                attributeName="opacity"
                begin="0s"
                dur="5s"
                values="0.1;1;1;0.1"
                keyTimes="0;0.4;0.6;1"
                repeatCount="indefinite"
              />
            </path>
          ))}

          {/* J with gradient */}
          <path
            aria-label="J"
            d="M0,40.9L1.4,40C3.6,43.4 5.2,44.3 8.8,44.3C12.3,44.3 15.1,41.6 15.1,36.6L15.1,17L16.6,17L16.6,36.4C16.6,39.7 15.9,41.9 14.4,43.6C13,45.3 11,46.2 8.7,46.2C4.4,46.3 1.8,44 0,40.9Z"
            style={{ fill: 'url(#linearGradient)', fillRule: 'nonzero' }}
          >
            <animate
              attributeName="opacity"
              begin="0s"
              dur="5s"
              values="0.8;1;1;0.8"
              keyTimes="0;0.4;0.6;1"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>

      <defs>
        <linearGradient
          id="linearGradient"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(9.96,-13.7255,13.7255,9.96,4.98,31.6016)"
        >
          <stop
            offset="0"
            style={{ stopColor: 'rgb(210,50,160)', stopOpacity: 1 }}
          />
          <stop
            offset="1"
            style={{ stopColor: 'rgb(255,120,0)', stopOpacity: 1 }}
          />
        </linearGradient>
      </defs>
    </svg>
  )
}
